export default "__VITE_ASSET__Bibw9bDe__"